class Timer {
  __timer = 0;
  __count = 9999;
  __current = -0;
  __step_event = function () {};
  __duration = 160;

  target = -1;
  round = [];

  start(options) {
    this.stop();

    this.target = options.target;
    this.round = options.round;
    this.__step_event = options.onStep;
    this.__end_event = options.onEnd;
    this.__current = -1;

    this.calcCount();
    this.__step();
  }

  calcCount() {
    if (this.target > -1) {
      let index = this.__current % this.round.length;
      // 如果当前就是呢
      if (this.round[index] == this.target) {
        this.__count = this.__current + this.round.length;
      } else {
        let find = -1;
        let add = 0;
        for (let i = index + 1; i < this.round.length; i++) {
          add++;
          if (this.round[i] == this.target) {
            find = i;
            break;
          }
        }
        if (find < 0) {
          for (let i = 0; i < index; i++) {
            add++;
            if (this.round[i] == this.target) {
              find = i;
              break;
            }
          }
        }

        if (add < 5) {
          this.__count = this.__current + add + this.round.length;
        } else {
          this.__count = this.__current + add;
        }
      }
    } else {
      this.__count = 9999;
    }
  }

  calcTime() {
    let half = Math.round(this.round.length / 2);
    if (this.__current < half) {
      return Math.abs(half - this.__current) * this.__duration;
    } else if (this.__current > this.__count - half) {
      return Math.abs(this.__current - this.__count) * this.__duration;
    } else {
      return this.__duration;
    }
  }

  __step = () => {
    this.__current++;
    this.__step_event(this.__current);

    if (this.__current >= this.__count) {
      this.end();
      return;
    }

    let time = this.calcTime();
    this.__timer = window.setTimeout(this.__step, time);
  };

  stop() {
    window.clearTimeout(this.__timer);
  }

  end() {
    this.__end_event(this.target);
  }

  setTarget(value) {
    this.target = value;
    this.calcCount();
  }
}

export default Timer;
